<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Group</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field  v-model="Form.name" label="Name" placeholder=" " v-validate="'required|max:50'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
	               <v-checkbox class="check_box" label="Primary Group" v-model="Form.isPrimaryAccountGroup"></v-checkbox>
	            </v-flex>

		        <v-flex xs12 sm12 md12 form-item @click="fn_openDialogNatureList" v-if="Form.isPrimaryAccountGroup">
               		<v-text-field  
               			readonly 
               			v-model="Form.natureTitle" 
               			label="Nature" 
               			placeholder=" " 
               			append-icon="arrow_drop_down"
               			v-validate="'required'" 
               			:error-messages="errors.collect('nature')" 
               			data-vv-name="nature" 
               			required>
               		</v-text-field>
	            </v-flex>


		        <div v-if="!Form.isPrimaryAccountGroup" full-width>
	            	<v-flex xs12 sm12 md12 form-item 
		            @click="fn_openParentGroupsDialog('android', 'AccountGroups', 'field_accountGroups')">

		               <v-text-field  
		               		readonly 
		               		v-model="Form.parentGroupName" 
		               		label="Parent Group" 
		               		placeholder=" "
		               		append-icon="arrow_drop_down"
		               		ref="field_accountGroups" 
			               	:onUpdate="fn_updateParentGroup" 
			               	v-validate="'required'" 
			               	data-vv-name="parent group"
			               	:error-messages="errors.collect('parent group')" 
			               	required>
		               	</v-text-field>
		            </v-flex>
	            </div>

			</v-layout>

<!-- 			<v-expansion-panel margin-top-ten>
			  	<v-expansion-panel-content>
			        <v-subheader nopadding slot="header">Other Details</v-subheader>

			        <v-divider></v-divider>

			      	<v-card>
			        	<v-layout row wrap padding-bottom-ten>
			        		<v-flex xs12 sm12 md12 form-item>
				               <v-checkbox class="check_box" :disabled="Form.disableAcRefDetails" hide-details right-align-checkbox label="Show Other Details" v-model="Form.acRefDetails"></v-checkbox>
				            </v-flex>

				            <v-flex xs12 sm12 md12 form-item>
				               <v-checkbox class="check_box" :disabled="Form.disableRunningCustomer" hide-details right-align-checkbox label="Running Customer" v-model="Form.runningCustomerGroup"></v-checkbox>
				            </v-flex>
			        	</v-layout>
			      	</v-card>
			    </v-expansion-panel-content>
			</v-expansion-panel> -->

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
			
				
		</v-form>

	    <dialog-nature-list ref="ref_dialogNatureList" :natureList="natureList" :selectedNature="Form.nature" :updateNature="fn_updateNature"></dialog-nature-list>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
		<dialog-selection-list ref="ref_dialogSelectionList" :fnAction="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;

import dialogNatureList from './dialogs/dialog_nature'
import dialogDiscard from '../../../dialogs/dialog_discard'
import dialogSelectionList from '../../../dialogs/dialog_selection_list'

import {draftMixin} from '../../../draft_mixin'

// import dialogDraftItems from '../../../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				// Form:{"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1,
				// 	"acRefDetails":false, "runningCustomerGroup":false, "disableRunningCustomer":false, "disableAcRefDetails":false, "draftItems":[], "createdDate":null, "modifiedDate":null
				// 	},
				Form:{"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true
					},
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				natureList: [{'id':101, 'title':'Assets'}, {'id':102, 'title':'Expenses'}, {'id':103, 'title':'Income'}, {'id':104, 'title':'Liabilities'}],

				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,

				// loadedFromDraft:false
			}
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     // this.fn_saveToLocalStorage(this);
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		components:{
			'dialog-nature-list': dialogNatureList,
			'dialog-discard': dialogDiscard,
			'dialog-selection-list':dialogSelectionList
			// 'dialog-draft-items': dialogDraftItems
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_updateNature: function (item) {
				this.Form.nature = item.id;
				this.Form.natureTitle = item.title;
				this.errors.remove('nature');
				this.fn_closeDialogWeb();
			},

			fn_openDialogNatureList: function(){
				this.fn_openDialogWeb('web', 'Nature', 'ref_dialogNatureList')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialogWeb: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},
			
			// fn_openParentGroupsDialog: function(platform, name, ref){

			// 	let viewDialogObject = { ToolbarTitle:"Account Group", fnName:"AccountGroupDialog", action:"new", ref:ref, dbSearch:true };

			// 	if(this.Form.parentAccountGroupId && this.Form.parentGroupName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.parentAccountGroupId, "itemName":this.Form.parentGroupName};
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },
			
			fn_openParentGroupsDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Account Group";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.parentAccountGroupId && this.Form.parentGroupName){
					paramObject.defaultValue = {"id":this.Form.parentAccountGroupId, "name":this.Form.parentGroupName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accountgroups', tagId, paramObject, ref);

			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_updateParentGroup: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.parentAccountGroupId = selectedValueId;
		        	this.Form.parentGroupName = selectedValueName;
		        	this.fn_get(selectedValueId);
		        	this.errors.remove('parent group');
				}
				else{
					this.Form.parentAccountGroupId = null;
		        	this.Form.parentGroupName = null;
		        	// this.Form.runningCustomerGroup = false;
					// this.Form.disableRunningCustomer = false;
					// this.Form.acRefDetails = false;
					// this.Form.disableAcRefDetails = false
				}
				this.$forceUpdate();
				this.fn_saveDraft(this.Form.name);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('AccountGroups', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast('Already exists with this name');
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = 'accountGroup';
					data.id = this.Form.accountGroupId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("master_items_state")){
						let obj = JSON.parse(localStorage.getItem("master_items_state"));
						obj.itemId = self.Form.accountGroupId;
						localStorage.setItem("master_items_state",JSON.stringify(obj));
					}

					self.$router.go(-1);
				});
			},

			fn_post: function(){
				// !this.Form.accountGroupId ? this.Form.accountGroupId = this.guid() : '';
				if(!this.Form.accountGroupId){
					this.Form.accountGroupId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.name = this.Form.name.trim();

				if(this.Form.isPrimaryAccountGroup){
					// this.Form.parentAccountGroupId = this.Form.accountGroupId;
					this.Form.parentAccountGroupId = null;
					this.Form.parentGroupName = null;
				}
				else{
					this.Form.nature = null;
					this.Form.natureTitle = null;
				}

				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_getNature: function (id) {
				for(let i=0;i<this.natureList.length;i++){
					if(this.natureList[i].id == id){
						return this.natureList[i].title;
						break;
					}
				}
			},

			fn_get: function(itemId, copyData, bindData){
				var self = this;
				this.unwatch = true;
				this.Form.isNew = false;
				this.getData('AccountGroups', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							
					        var item = JSON.parse(response);

					        if(bindData){
					        	self.fn_bindData(item, copyData);
					        }
					        
					        
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function(item, copyData){
				this.unwatch = true;
				this.Form.name = item.name;
		        this.Form.accountGroupId = item.accountGroupId;
		        
		        this.Form.groupTypeId = item.groupTypeId;
		        this.Form.isPrimaryAccountGroup = item.isPrimaryAccountGroup;

		        if(!this.Form.isPrimaryAccountGroup){
		          	this.Form.parentAccountGroupId = item.parentAccountGroupId;
		          	this.Form.parentGroupName = item.parentAccountGroup.name;
		        }
		        else{
		          	this.Form.parentAccountGroupId = null;
		          	this.Form.parentGroupName = null;

		          	this.Form.nature = item.nature;
		          	this.Form.natureTitle = this.fn_getNature(item.nature);
		        }

		        this.Form.isSystem = item.isSystem;
		        this.Form.status = item.status;

		        // this.Form.runningCustomerGroup = item.runningCustomerGroup;
		        // this.Form.acRefDetails = item.acRefDetails;

		        if(copyData){
		          	this.Form.accountGroupId=null;
		          	this.Form.isSystem = 0;
					this.showToast("Account Group copied");
		        }

		        this.$root.fn_copyFormObject(this.Form, this.formId);
			},

			fn_clearForm: function(){
				// this.Form = {"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1,
				// 	"acRefDetails":false, "runningCustomerGroup":false, "disableRunningCustomer":false, "disableAcRefDetails":false, "draftItems":[], "createdDate":null, "modifiedDate":null
				// };
				this.Form = {"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true
				};
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;
				
				if(this.Form.accountGroupId){
					this.fn_get(this.Form.accountGroupId, null, true);
				}
				else{
					this.fn_clearForm();
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
				
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Account Groups";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "accountGroup":
					    	this.fn_updateParentGroup(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			},

		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('accountgroupsforms')){
				formsArray = JSON.parse(localStorage.getItem('accountgroupsforms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('accountgroupsforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}
			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){

				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);
			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('Account Groups', true) : '';

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Master', 'Account Groups');
			this.fn_setDraftData('temp', 'Account Groups');

		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='accountsGroupItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'accountsGroupItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'accountGroupDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData, true);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData, true);
	  			}

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('accountgroupsforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }

				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// if(this.loadedFromDraft || (!areObjectsEqual && this.askToDiscard)){
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('accountgroupsforms', function(){
						next();
					})
					// this.$root.fn_deleteFormObject(this.formId);
					// !this.saveDraft ? this.fn_removeDraft(this.draftStorageId) : '';
					// localStorage.removeItem('accountgroupsforms');
				}
				
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/account_groups/form.vue